import React from "react";
import { Content, Theme } from "@carbon/react";

import "./app.scss";
import { AppHeader, AppLayout } from "./components";

function App() {
  return (
    <>
      <Theme theme="g10">
        <AppHeader />
      </Theme>

      <Content>
        <AppLayout />
      </Content>
    </>
  );
}

export default App;
